import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import './ApiControlContentItem.scss';
import { RootState } from '../../../redux/store';

type ApiControlContentItemProps = {
	title: string;
	children: ReactNode;
};

const ApiControlContentItem: FC<ApiControlContentItemProps> = ({
	title,
	children,
}) => {
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	return (
		<div className={`ApiControlContentItem ${isDarkTheme ? 'dark' : 'light'}`}>
			<div
				className={`ApiControlContentItem__title ${isDarkTheme ? 'dark' : 'light'}`}
			>
				<Typography sx={{ mb: 1, fontWeight: 500 }}>{title}</Typography>
			</div>
			<div className="ApiControlContentItem__content">{children}</div>
		</div>
	);
};

export default ApiControlContentItem;
